import "./add-remove-list.less";
import { Subject } from 'rxjs';
import * as $ from 'jquery';

export class AddRemoveList {

    listFrom: Array<string> = [];
    listTo: Array<string> = [];
    listData: Array<{ label: string, value: string }>;
    id: string;


    init = (data, id) => {
        this.id = id;
        AddRemoveListUI.init().subscribe(this.handleEvents);
        this.listData = data;
        this.removeAll();

    }

    initFrontend(element) {
        this.id = AddRemoveListUI.getFieldId(element);
        this.listData = AddRemoveListUI.readList(this.id);
        AddRemoveListUI.init().subscribe(this.handleEvents);
        AddRemoveListUI.readInitialList();

    }

    handleEvents = (params: { event: string, fieldId: string, selection?: Array<string> }) => {
        if (params.fieldId != this.id) return;
        switch (params.event) {
            case 'add-all':
                this.addAll();
                break;
            case 'remove-all':
                this.removeAll()
                break;
            case 'add-selected':
                this.addToListTo(params.selection);
                break;
            case 'remove-selected':
                this.addToListFrom(params.selection);
                break;
        }
    }

    addToListFrom = (elementIds: Array<string>) => {
        this.listFrom = elementIds.concat(this.listFrom);
        this.listTo = this.listTo.filter(el => elementIds.indexOf(el) == -1);
        AddRemoveListUI.appendListToFromList(elementIds.map(id => this.getElementByID(id)), this.id);
        AddRemoveListUI.addInputs(this.listTo, this.id);
    }

    addToListTo = (elementIds: Array<string>) => {
        this.listTo = elementIds.concat(this.listTo);
        this.listFrom = this.listFrom.filter(el => elementIds.indexOf(el) == -1);
        AddRemoveListUI.appendListToToList(elementIds.map(id => this.getElementByID(id)), this.id);
        AddRemoveListUI.addInputs(this.listTo, this.id);
    }

    refresh() {
        AddRemoveListUI.refresh(this.listData, this.listTo, this.listFrom, this.id);
        AddRemoveListUI.addInputs(this.listTo, this.id);
    }

    addAll = () => {
        this.addToListTo(this.listData.map(d => d.value));
        this.refresh();
    }

    removeAll = () => {
        this.addToListFrom(this.listData.map(d => d.value));
        this.refresh();
    }

    getElementByID = id => {
        let f = this.listData.filter(d => d.value == id);
        if (f.length)
            return f[0];
        return null;
    }
}


export class AddRemoveListUI {

    static events: Subject<{ event: string, fieldId: string, selection?: Array<string> }> = new Subject();


    static readInitialList = () => {
        $(document).ready(() =>
            $('.add-remove-list-component').each((i, comp) => {
                let list = $(comp);
                if(list.attr('data-initial-list')){
                    let items = JSON.parse(list.attr('data-initial-list'));
                    if (Array.isArray(items)) {
                        AddRemoveListUI.events.next({ event: 'add-selected', fieldId: AddRemoveListUI.getFieldId(list[0]), selection: items.map(d => d.id) })
                    }

                }
            }));
    }

    static createListElement = (data: { value: string, label: string }) => {
        let { value, label } = data;
        return `<div class="add-remove-list-item" data-selected="false" data-id="${value}"><span>${label}</span>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41z"/></svg>
</div>`;
    };

    static addInput(value, parentElement) {
        let parent = $(parentElement);
        let fieldId = parent.attr('data-field-id');
        parent.find('.list-to')
            .prepend(`<input type="hidden" name="${fieldId}[]" ${parent.attr('data-required') == 'true' ? 'required' : ''} value="${value}">`);
    }

    static getFieldId(element) {
        let parent = $(element).closest('[data-field-id]');
        if (parent.length) {
            return parent.attr('data-field-id');
        }
        return "";
    }

    static addInputs(toList, fieldId) {
        let parent = AddRemoveListUI.getParent(fieldId);
        parent.find('.list-to input:not(.validation-hack)').remove();
        if (toList.length == 0) {
            if (parent.attr('data-required') == 'true') {
                AddRemoveListUI.addInput('', parent);
            }
        }
        else
            toList.forEach(id => AddRemoveListUI.addInput(id, parent));
    }

    static emptyToList(parentElement) {
        parentElement.find(`.list-to .add-remove-list-item`).remove();
    }

    static emptyFromList(parentElement) {
        parentElement.find(`.list-from .add-remove-list-item`).remove();
    }

    static appendToToList = (data: { value: string, label: string }, parentElement) => {
        let { value, label } = data;
        $(parentElement).find(`.list-from [data-id="${value}"]`).remove();
        $(parentElement).find(`.list-to [data-id="${value}"]`).remove();
        $(parentElement).find('.list-to .list-elements').prepend(AddRemoveListUI.createListElement(data));
    };

    static appendListToToList = (data: Array<{ value: string, label: string }>, fieldId) => {
        data.forEach(d => AddRemoveListUI.appendToToList(d, AddRemoveListUI.getParent(fieldId)));
    }

    static appendListToFromList = (data: Array<{ value: string, label: string }>, fieldId) => {
        data.forEach(d => AddRemoveListUI.appendToFromList(d, AddRemoveListUI.getParent(fieldId)));
    }

    static appendToFromList = (data: { value: string, label: string }, parentElement) => {
        let { value, label } = data;
        $(parentElement).find(`.list-to [data-id="${value}"]`).remove();
        $(parentElement).find(`.list-from [data-id="${value}"]`).remove();
        $(parentElement).find('.list-from').prepend(AddRemoveListUI.createListElement(data));
    };

    static getParent(fieldId) {
        return $(`.add-remove-list-component[data-field-id="${fieldId}"]`);
    }

    static refresh(listData, listTo, listFrom, id) {
        let parentElement = AddRemoveListUI.getParent(id);
        AddRemoveListUI.printListTo(listData, listTo, parentElement);
        AddRemoveListUI.printListFrom(listData, listFrom, parentElement);
    }

    static printListTo(listData, listTo, parentElement) {
        AddRemoveListUI.emptyToList(parentElement);
        listData.filter(item => listTo.indexOf(item.value) > -1).forEach(item => AddRemoveListUI.appendToToList(item, parentElement));
    }

    static printListFrom(listData, listFrom, parentElement) {
        AddRemoveListUI.emptyFromList(parentElement);
        listData.filter(item => listFrom.indexOf(item.value) > -1).forEach(item => AddRemoveListUI.appendToFromList(item, parentElement));
    }

    static getSelection = (root) => {
        let selection = [];
        root.find('[data-selected=true]').each((i, el) => {
            selection.push($(el).attr('data-id'));
        });
        return selection;
    }

    static readList(id) {
        let parent = AddRemoveListUI.getParent(id);
        let list = [];
        if (parent) {

            let elems = parent.find('.list-from .add-remove-list-item');
            elems.each((i, el) => {
                let element = $(el);
                list.push({ label: element.find('span').text(), value: element.attr('data-id') });
            });
        }
        return list;
    }



    static init = () => {
        $(document).off('click touchstart', '.add-remove-list-component .list-container .add-remove-list-item');
        $(document).on('click touchstart', '.add-remove-list-component .list-container .add-remove-list-item', ev => {
            let item = $(ev.target).closest('.add-remove-list-item');
            if (item) {
                item.attr('data-selected', (item.attr('data-selected') == 'true') ? 'false' : 'true');
            }
        });
        $(document).off('click touchstart', '.add-remove-list-component  .add-all');
        $(document).on('click touchstart', '.add-remove-list-component .add-all', (ev) => {
            let fieldId = AddRemoveListUI.getFieldId(ev.target);
            if (fieldId)
                AddRemoveListUI.events.next({ event: 'add-all', fieldId: fieldId });
        });//list.addAll($(ev.target).closest(document)));
        $(document).off('click touchstart', '.add-remove-list-component .remove-all');
        $(document).on('click touchstart', '.add-remove-list-component .remove-all', (ev) => {
            let fieldId = AddRemoveListUI.getFieldId(ev.target);
            if (fieldId)
                AddRemoveListUI.events.next({ event: 'remove-all', fieldId: fieldId });
        });
        //(ev) => list.removeAll($(ev.target).closest(document)));
        $(document).off('click touchstart', '.add-remove-list-component .add-selected');
        $(document).on('click touchstart', '.add-remove-list-component .add-selected', (ev) => {
            let fieldId = AddRemoveListUI.getFieldId(ev.target);
            let parent = AddRemoveListUI.getParent(fieldId);
            if (fieldId)
                AddRemoveListUI.events.next({ event: 'add-selected', fieldId: fieldId, selection: AddRemoveListUI.getSelection(parent.find('.list-from')) });
        });
        $(document).off('click touchstart', '.add-remove-list-component .remove-selected');
        $(document).on('click touchstart', '.add-remove-list-component .remove-selected', (ev) => {
            let fieldId = AddRemoveListUI.getFieldId(ev.target);
            let parent = AddRemoveListUI.getParent(fieldId);
            if (fieldId)
                AddRemoveListUI.events.next({ event: 'remove-selected', fieldId: fieldId, selection: AddRemoveListUI.getSelection(parent.find('.list-to')) });
        });

        return AddRemoveListUI.events;
    };
}
